export enum FORM_FIELD_TYPES {
    TEXT = 'text',
    CITY = 'city',
    AGREEMENT = 'agreement',
    TEXTAREA = 'textarea',
    SELECT = 'select',
    CHECKBOX = 'checkbox'
}
